export const RbacSerializer = (data) => {
    if(data)
    return {
        tenant: data.tenant_id,
        id: data.rbac_id,
        name: data.rbac_name,
        domains: data.domains,
        insertDate: data.date_of_insert,
        insertUser: data.user_of_insert,
        changeDate: data.date_of_change,
        changeUser: data.user_of_change
    }
    return null
};